<div id="conventions" class="popup maintenance-form">
    <h2>Chat/Conventions</h2>
    <div id="conventions-grid">
        {#each conventions as convention}
            <input type="radio" name="convention" value="{convention}"
            on:click={() => displayConvention(convention)}>{convention}
        {/each}
    </div>
    <div class="button-grid">
        <button class="select-button" on:click={close}>Close</button>
    </div>
</div>

<div class="popup" id= "convention-display">
    <div id="convention-title"></div>
    <div id="display-grid">
        <div id="convention-text"></div>

        <div id="chat-select">
            {#each chats as chat}
                <span class="radio"><input type="radio" name="chat" value="{chat}"
                on:click={() => copyChat(chat)}></span><span class="chat-text">{@html chat}</span>
            {/each}
        </div>
    </div>
    <div class="button-grid">
        <button class="select-button" on:click={close}>Close</button>
    </div>
</div>


<style>
    #conventions {
        display: none;
        top: 20vh;
        left: 20vw;
        width: 66vw;
    }
    #conventions-grid {
        display: grid;
        grid-template-columns: 2vw auto;
    }

    #convention-display {
        display: none;
        flex-direction: column;
        position: absolute;
        top: 20vh;
        left: 20vw;
        width: 66vw;
        padding: 1vh;

        background-color: #cccccc;
        border-style: solid;
        border-radius: 2vh;
        border-width: .25vh;
        border-color: black;
    }

    #convention-text {
        width: 33vw;
        height: 33vh;
        border-radius: 1vh;
        background-color: white;
        padding: 0.5vh;
    }

    #chat-select {
        display: grid;
        grid-template-columns: 2vw auto;
        align-content: start;
        width: 33vw;
    }

    #convention-title {
        margin: 0 auto;
        font-size: 2vh;
    }

    #convention-text {
        width: 66vw;
        height: 60vh;
        border-radius: 1vh;
    }

    #display-grid {
        display: flex;
        flex-direction: row;
        gap: 0.5vw;
    }

    .button-grid {
        margin: 0 auto;
        padding: 1vh;
    }

    .radio {
        font-size: 0.2em;
    }
    .chat-text{
        margin-top: -1vh;
    }
</style>

<script>
    import { user } from './data-store';
    import { elementDisplay, setHTML, setText } from './utilities';
    import { suitToText, textToSuit } from './common'

    let convention_name = '';
    let first = '';

    let convention_text = '';

    $: conventions = getConventions($user);
    $: chats = []

    function getConventions(user) {
        let conventions = [];
        for (const [convention, value] of Object.entries(user.conventions)) {
            conventions.push(convention);
        }
        conventions.sort();
        if (!convention_name && conventions.length > 0) {
            convention_name = conventions[0];
        }
        first = conventions[0];
        return conventions;
    }

    function displayConvention(convention) {
        elementDisplay('conventions', 'none')
        elementDisplay('convention-display', 'flex');
        setText('convention-title', convention);
        let text = textToSuit($user.conventions[convention])
        text = text.replaceAll('\n', '<br>')
        setHTML('convention-text', text);
        chats = []
        let raw_chats = $user.chat[convention].split('\n');
        for (var raw_chat of raw_chats) {
            var chat = textToSuit(raw_chat)
            chats.push(chat);
        }

    }

    function copyChat(chat) {
        let text = suitToText(chat)
        navigator.clipboard.writeText(text);
    }

    function close() {
        elementDisplay('conventions', 'none')
        elementDisplay('convention-display', 'none')

        var allRadios = document.getElementsByName('convention');
        var x = 0;
        for(x = 0; x < allRadios.length; x++){
            allRadios[x].checked = false;
        }
    }

</script>